<template><el-upload action="#" accept=".jpg,.jpeg,.png,.gif,.webp" :show-file-list="false" :disabled="uploading" :http-request="upload"><el-button size="small" :loading="uploading">上传图片</el-button><img v-if="value" :src="value" class="cover-thumb" /></el-upload></template>
<script>
import { uploadWorkbenchMedia, imageExtensions } from './workbenchUpload'
export default {
  props: { value: String }, data() { return { uploading: false } },
  methods: { async upload(request) {
    this.uploading = true; this.$emit('uploading', true)
    try { const media = await uploadWorkbenchMedia(this.axios, request.file, imageExtensions); this.$emit('input', media.url); request.onSuccess({}) }
    catch (e) { request.onError(e); this.$message.error(e.message || '上传失败') }
    finally { this.uploading = false; this.$emit('uploading', false) }
  } }
}
</script>
<style scoped>.cover-thumb{display:block;max-height:100px;max-width:180px;margin:8px 0}</style>
